import { protectedAxiosInstance, axiosInstance } from 'helpers/api-calls';
import { createHeadersForApiCall, getUserId, getSessionUukey } from '../cookies';
import { formatOnlyProps } from 'helpers/formatting';

const planApiUrl = '/api/compact/plans';

/**
 * Get pending shifts
 * @param { Int } per_page - the amount of shifts to be returned
 * @param { Int } page - which page of shifts needs to be returned
 *
 * @return { Object } this contains the stats for the shifts (total count, current page, etc)
 *                    and then an array of the shifts
 */
export const getPlans = (location_id) =>
  protectedAxiosInstance.request({
    headers: createHeadersForApiCall(),
    method: 'GET',
    url: `${planApiUrl}`,
  });

/**
 * Create a Stripe Customer Portal session
 * @param { String } customerId - The Stripe customer ID
 * @return { Promise<string> } The URL to redirect to
 */
export const createStripePortalSession = async (customerId) => {
  try {
    const response = await protectedAxiosInstance.request({
      headers: createHeadersForApiCall(),
      method: 'POST',
      url: '/api/stripe/create-portal-session',
      data: {
        customerId,
        returnUrl: window.location.href
      }
    });
    return response.data.url;
  } catch (error) {
    console.error('Portal session request failed:', error.response?.data);
    throw error;
  }
};

/**
 * Create a Stripe Customer Session for embedded components
 * @param { String } locationId - The location ID
 * @param { Object } components - Stripe component scoping object (e.g. { pricing_table: { enabled: true } })
 * @return { Promise<string> } The client secret for the customer session
 */
export const createCustomerSession = async (locationId, components) => {
  try {
    const response = await protectedAxiosInstance.request({
      headers: createHeadersForApiCall(),
      method: 'POST',
      url: '/api/stripe/create-customer-session',
      data: {
        locationId,
        components,
      },
    });
    return response.data.clientSecret;
  } catch (error) {
    console.error('Customer session request failed:', error.response?.data);
    throw error;
  }
};